import $foreign from "./foreign.cjs";
var intAdd = $foreign.intAdd;
var intMul = $foreign.intMul;
var numAdd = $foreign.numAdd;
var numMul = $foreign.numMul;
export { intAdd, intMul, numAdd, numMul };
